var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center",class:{ 'displayNone': _vm.displayNone }},[_c('img',{attrs:{"src":"https://cdn.carizy.com/images/carizy_loader.gif","alt":"Loader"}})])}
var staticRenderFns = []

export { render, staticRenderFns }